export default __webpack_public_path__ + "static/media/isa-bg2.340f9401.jpg";